import { useCallback, useSyncExternalStore } from 'react';
import ModuleDomNodeStore from './ModuleDomNodeStore';
function subscribe(callback) {
  const unsubscribe = ModuleDomNodeStore.subscribe(callback);
  return unsubscribe;
}
export default function useModuleDomNodeStore(moduleName) {
  const getModuleDomNode = useCallback(() => {
    return ModuleDomNodeStore.get(moduleName);
  }, [moduleName]);
  return useSyncExternalStore(subscribe, getModuleDomNode);
}